import { Divider, FlexLayout, H3 } from '@deity/falcon-ui';
import type { IPropertyBag } from '@deity-io/di-data-basics';
import { mapRecordToArray } from '@deity-io/di-data-basics';
import { PackagePopoutSkeleton } from 'components';
import PackageNameLine from 'components/Packages/PackagePopout/PackageNameLine';
import { CACHE_FIRST } from 'contracts/constants';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useGetPackageLazyQuery } from 'services/graphql/generated/hooks';
import { validate as validateUuid } from 'uuid';
import type { IClusterStatePackage, IRuntimeState } from '../IRuntimeState';
import { PackagePopoutVersion } from './PackagePopoutVersion';

type VersionDashboardProps = {
  packageKey: string;
  // packageVersionKey?: string;
  clusterPackage: IClusterStatePackage;
  services: IRuntimeState['services'];
};
export const PackagePopout: FC<VersionDashboardProps> = ({ packageKey, clusterPackage, services }) => {
  const [getPackage, { loading: packageLoading, data: packageData }] = useGetPackageLazyQuery(CACHE_FIRST);

  useEffect(() => {
    if (packageKey && validateUuid(packageKey)) {
      getPackage({
        variables: {
          uuid: packageKey
        }
      });
    }
  }, [packageKey]);

  const groupedPipes: Record<string, { uuid: string; versions: Record<string, IPropertyBag> }> = {};

  mapRecordToArray(clusterPackage.versions, (version, versionKey) => {
    mapRecordToArray(version.pipelines, (pipe, pipeKey) => {
      if (!groupedPipes[pipe.uuid]) {
        groupedPipes[pipe.uuid] = { uuid: pipe.uuid, versions: {} };
      }
      const groupPipe = groupedPipes[pipe.uuid];
      mapRecordToArray(pipe.instances, (instance, instanceKey) => {
        instance.data = instance.data || {};
      });
    });
  });

  return packageLoading ? (
    <PackagePopoutSkeleton />
  ) : (
    <FlexLayout flexDirection="column" width="full">
      <FlexLayout p="xl" style={{ paddingTop: '0px' }} flexDirection="column">
        <H3 color="secondary" fontWeight="bold" fontSize="xs" mt="md">
          PACKAGE
        </H3>
        <PackageNameLine packageName={packageData?.getPackage.name || packageKey} />
        {packageLoading && (
          <H3 color="secondary" fontWeight="bold" fontSize="xs" mt="md">
            DESCRIPTION
          </H3>
        )}
        {packageData?.getPackage.description}
      </FlexLayout>
      <Divider css={{ borderColor: '#DADFE4' }} />
      {mapRecordToArray(clusterPackage.versions, (version, versionKey) => (
        <PackagePopoutVersion
          key={versionKey}
          packageVersion={version}
          packageVersionKey={versionKey}
          accountUuid={clusterPackage.accountUuid}
          services={services}
        />
      ))}
    </FlexLayout>
  );
};
